//---------------------------common -----------------------
export const SET_STORAGE_TIMESTAMP = 'SET_STORAGE_TIMESTAMP';
export const REMOVE_STORAGE = 'REMOVE_STORAGE';
export const FETCHING_DATA = 'FETCHING_DATA';
export const DATA_FETCHED = 'DATA_FETCHED';
export const ERROR_FETCHING = 'ERROR_FETCHING';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const SHOW_DIRTY_MODAL = 'SHOW_DIRTY_MODAL';
export const SET_DIRTY = 'SET_DIRTY';
export const UPDATE_CLIENT_VIEW_PORT = 'UPDATE_CLIENT_VIEW_PORT';
export const INITIAL_SERVER_DATA = 'INITIAL_SERVER_DATA';
export const SET_URL_PARAMS = 'SET_URL_PARAMS';
export const TRACK_GA_EVENT = 'TRACK_GA_EVENT';
export const TRACK_GA_PAGEVIEW = 'TRACK_GA_PAGEVIEW';
//---------------------------login -----------------------
export const LOG_IN_STATUS = 'LOG_IN_STATUS';
export const FORGET_PASSWORD = 'FORGET_PASSWORD';
export const SHOW_FACEBOOK_POPUP = 'SHOW_FACEBOOK_POPUP';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const ENABLE_FB_BUTTON = 'ENABLE_FB_BUTTON';
//---------------------------store -----------------------
export const LOAD_CATEGORIES = 'LOAD_CATEGORIES';
export const CHANGE_ITEM_QUANTITY = 'CHANGE_ITEM_QUANTITY';
export const LOAD_ITEMS = 'LOAD_ITEMS';
export const SET_POST_ACTION_KEY = 'SET_POST_ACTION_KEY';
export const CHANGE_CATEGORY = 'CHANGE_CATEGORY';
export const SET_ACTIVE_ORDER = 'SET_ACTIVE_ORDER';
export const SET_SUMMARY = 'SET_SUMMARY';
export const MESSAGE_DATA = 'MESSAGE_DATA';
export const SET_SHOULD_RELOAD_DATA = 'SET_SHOULD_RELOAD_DATA';
export const RESET_PASSWORD_EMAIL_SENT = 'RESET_PASSWORD_EMAIL_SENT';
export const RESET_STATUS = 'RESET_STATUS';
export const SET_DELIVERY_DAY_FILTER = 'SET_DELIVERY_DAY_FILTER';
export const ADD_ITEM = 'ADD_ITEM';
export const SELECT_PAYMENT_PLAN = 'SELECT_PAYMENT_PLAN';
export const SET_COUPON = 'SET_COUPON';
export const REMOVE_COUPON = 'REMOVE_COUPON';
export const SET_STORE_COMMENT = 'SET_STORE_COMMENT';
export const STORE_CREDITS_DATA = 'STORE_CREDITS_DATA';
export const SET_REMAINING_CREDITS = 'SET_REMAINING_CREDITS';
export const CHANGE_EXTRA_ITEM_QUANTITY = 'CHANGE_EXTRA_ITEM_QUANTITY';
export const SET_UNAVAILABLE_ITEMS = 'SET_UNAVAILABLE_ITEMS';
export const UPDATE_ITEMS_PROPS = 'UPDATE_ITEMS_PROPS';
export const UPDATE_ITEMS_AVAILABILITY = 'UPDATE_ITEMS_AVAILABILITY';
export const CLEAR_SHARES_SELECTION = 'CLEAR_SHARES_SELECTION';
export const UPDATE_TOTALS = 'UPDATE_TOTALS';
export const SET_ALLOW_ORDER_EDIT = 'SET_ALLOW_ORDER_EDIT';
export const SET_WEB_ORDER_COUPON = 'SET_WEB_ORDER_COUPON';
export const SET_DROPDOWN_CLOSED = 'SET_DROPDOWN_CLOSED';
export const SHOW_UPDATE_RECURRING_MODAL = 'SHOW_UPDATE_RECURRING_MODAL';
export const SET_RECURRING_ORDER_DATA = 'SET_RECURRING_ORDER_DATA';
export const SET_RECURRING_ITEM = 'SET_RECURRING_ITEM';
export const SHOW_LOGIN_SIGNUP_MODAL = 'SHOW_LOGIN_SIGNUP_MODAL';
//---------------------------join -----------------------
export const GOTO_STEP = 'GOTO_STEP';
export const SET_SIGNUP_DATA = 'SET_SIGNUP_DATA';
export const CLEAR_SIGNUP_DATA = 'CLEAR_SIGNUP_DATA';
export const SET_SHARES_DATA = 'SET_SHARES_DATA';
export const JOIN_CHANGE_ITEM_QUANTITY = 'JOIN_CHANGE_ITEM_QUANTITY';
export const JOIN_SET_ITEM_SCHEDULE = 'JOIN_SET_ITEM_SCHEDULE';
export const SET_SELECTED_METHOD = 'SET_SELECTED_METHOD';
export const SET_MAP_PROPS = 'SET_MAP_PROPS';
export const INIT_MAP_PROPS = 'INIT_MAP_PROPS';
export const SET_SIGNUP_COMMENTS = 'SET_SIGNUP_COMMENTS';
export const SET_TERMS_SELECTED = 'SET_TERMS_SELECTED';
export const SET_HOME_DELIVERY_INSTRUCTIONS = 'SET_HOME_DELIVERY_INSTRUCTIONS';
export const SET_CREATEING_SUBSCRIPTION = 'SET_CREATEING_SUBSCRIPTION';
export const SET_INVALID_OPTION_SCHEDULE_MESSAGE = 'SET_INVALID_OPTION_SCHEDULE_MESSAGE';
export const SET_COUPON_STATUS = 'SET_COUPON_STATUS';
export const SET_MULTI_ORDER_EDIT = 'SET_MULTI_ORDER_EDIT';
//-------------------------- member details --------
export const INIT_MEMBER_DETAILS = 'INIT_MEMBER_DETAILS';
export const SET_MEMBER_DATA = 'SET_MEMBER_DATA';
export const SET_MEMBER_ACTION = 'SET_MEMBER_ACTION';
export const SET_MEMBER_KEY = 'SET_MEMBER_KEY';
//------------------------- account ---------------
export const SET_ACCOUNT_DATA = 'SET_ACCOUNT_DATA';
export const SET_ACCOUNT_MODE = "SET_ACCOUNT_MODE";
export const SET_SUBSCRIPTION_NEXT_DELIVERY_DATE = 'SET_SUBSCRIPTION_NEXT_DELIVERY_DATE';
export const SET_PICKUP_SITE = 'SET_PICKUP_SITE';
export const SET_WAIT_LIST_PICKUP_SITE = 'SET_WAIT_LIST_PICKUP_SITE';
export const SET_PICKUP_SITES_DELIVERY_DATE = 'SET_PICKUP_SITES_DELIVERY_DATE';
export const SET_PICKUP_SITES_DELIVERY_DATE_ACTUAL = 'SET_PICKUP_SITES_DELIVERY_DATE_ACTUAL';
export const SET_CAN_SAVE_DELIVERY_HOLD = 'SET_CAN_SAVE_DELIVERY_HOLD';
export const SET_CUSTOM_AMOUNT = 'SET_CUSTOM_AMOUNT';
export const SET_ALLOW_CONTINUE_PAYMENT = 'SET_ALLOW_CONTINUE_PAYMENT';
export const SET_VACATIONS = 'SET_VACATIONS';
export const SET_REQUIRED_MAKE_UP_DATA = 'SET_REQUIRED_MAKE_UP_DATA';
export const SET_SHOW_ADDRESS_VALIDATION_MESSAGE = 'SET_SHOW_ADDRESS_VALIDATION_MESSAGE';
//----------------------------- payment -------------
export const SET_PAYMENT_TYPE = 'SET_PAYMENT_TYPE';
export const SET_PAYMENT_PLAN = 'SET_PAYMENT_PLAN';
export const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD';
//------------------------------contact validation --------
export const SET_SHOW_PASSWORD = "SET_SHOW_PASSWORD";
export const CONTACT_INFO_STEP = 'CONTACT_INFO_STEP';
export const SET_CONTACT_DETAILS = 'SET_CONTACT_DETAILS';
export const SET_UPDATE_MEMBER_ERROR = 'SET_UPDATE_MEMBER_ERROR';
export const SET_ADDRESS_VALIDATION_ERROR = 'SET_ADDRESS_VALIDATION_ERROR';
export const SET_LAT_LNG = 'SET_LAT_LNG';
export const SET_ADDRESS_VALIDATION_ERROR_NO_ACTION = 'SET_ADDRESS_VALIDATION_ERROR_NO_ACTION';
//-------------------------------store coupons -------------
export const SET_STORE_HAS_COUPONS = 'SET_STORE_HAS_COUPONS';
export const SET_HAS_ALREADY_COUPON = 'SET_HAS_ALREADY_COUPON';
//----------------------------------------------------------
export const SET_WEB_ORDER = 'SET_WEB_ORDER';
export const SET_ON_PERMANENT_HOLD = 'SET_ON_PERMANENT_HOLD';


// WEBPACK FOOTER //
// ./src/actions/actionTypes.js